<template>
  <div class="team">
    <h1 class="part-title tc animated wow fadeInUp">{{ $t('Home.Components.TeamDescription.SupportYouCanGetFromOurTeam') }}</h1>
    <el-carousel :interval="3000" type="card" :height="bannerHeight + 'px'" indicator-position="none" style="margin-top:80px" arrow="never" class="carousel-box animated wow fadeInUp">
      <el-carousel-item>
        <div style="width:100%;" class="f-c">
          <!-- <img src="@/assets/img/homePage/team (1).png" class="carousel-img" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(1).jpg" :width="561" :height="400" />
        </div>
        <h6 class="team-title">{{ $t('Home.Components.TeamDescription.ProductDevelopment') }}</h6>
        <p class="team-s-title">{{ $t('Home.Components.TeamDescription.Tips1') }}</p>
      </el-carousel-item>
      <el-carousel-item>
        <div style="width:100%;" class="f-c-c">
          <!-- <img src="@/assets/img/homePage/team (2).png" class="carousel-img" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(2).jpg" :width="561" :height="400" />
        </div>
        <h6 class="team-title">{{ $t('Home.Components.TeamDescription.QualityControl') }}</h6>
        <p class="team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips2') }}
        </p>
      </el-carousel-item>
      <el-carousel-item>
        <div style="width:100%;" class="f-c-c">
          <!-- <img src="@/assets/img/homePage/team (3).png" class="carousel-img" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(3).jpg" :width="561" :height="400" />
        </div>
        <h6 class="team-title">{{ $t('Home.Components.TeamDescription.CustomerService') }}</h6>
        <p class="team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips3') }}
        </p>
      </el-carousel-item>
      <el-carousel-item>
        <div style="width:100%;" class="f-c-c">
          <!-- <img src="@/assets/img/homePage/team (4).png" class="carousel-img" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(4).jpg" :width="561" :height="400" />
        </div>
        <h6 class="team-title">{{ $t('Home.Components.TeamDescription.TechnologyDevelopment') }}</h6>
        <p class="team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips4') }}
        </p>
      </el-carousel-item>
      <el-carousel-item>
        <div style="width:100%;" class="f-c-c">
          <!-- <img src="@/assets/img/homePage/team (5).png" class="carousel-img" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(5).jpg" :width="561" :height="400" />
        </div>
        <h6 class="team-title">{{ $t('Home.Components.TeamDescription.LogisticWarehouses') }}</h6>
        <p class="team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips5') }}
        </p>
      </el-carousel-item>
    </el-carousel>
    <div class="w team-mobile">
      <div class="team-main animated wow fadeInUp">
        <div class="team-card f-c">
          <!-- <img src="@/assets/img/homePage/team (1).png" style="width:100%" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(1).jpg" :width="317" :height="218" />
        </div>
        <h6 class="mobile-team-title ">{{ $t('Home.Components.TeamDescription.ProductDevelopment') }}</h6>
        <p class="mobile-team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips6') }}
        </p>
      </div>
      <div class="team-main animated wow fadeInUp">
        <div class="team-card f-c">
          <!-- <img src="@/assets/img/homePage/team (2).png" style="width:100%" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(2).jpg" :width="317" :height="218" />
        </div>
        <h6 class="mobile-team-title">{{ $t('Home.Components.TeamDescription.QualityControl') }}</h6>
        <p class="mobile-team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips2') }}
        </p>
      </div>
      <div class="team-main animated wow fadeInUp">
        <div class="team-card f-c">
          <!-- <img src="@/assets/img/homePage/team (3).png" style="width:100%" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(3).jpg" :width="317" :height="218" />
        </div>
        <h6 class="mobile-team-title">{{ $t('Home.Components.TeamDescription.CustomerService') }}</h6>
        <p class="mobile-team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips3') }}
        </p>
      </div>
      <div class="team-main animated wow fadeInUp">
        <div class="team-card f-c">
          <!-- <img src="@/assets/img/homePage/team (2).png" style="width:100%" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(4).jpg" :width="317" :height="218" />
        </div>
        <h6 class="mobile-team-title">{{ $t('Home.Components.TeamDescription.QualityControl') }}</h6>
        <p class="mobile-team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips2') }}
        </p>
      </div>
      <div class="team-main animated wow fadeInUp">
        <div class="team-card f-c">
          <!-- <img src="@/assets/img/homePage/team (5).png" style="width:100%" alt="" lazy  /> -->
          <oss-img src="https://img.kakaclo.com/web-img/team-(5).jpg" :width="317" :height="218" />
        </div>
        <h6 class="mobile-team-title">{{ $t('Home.Components.TeamDescription.LogisticWarehouses') }}</h6>
        <p class="mobile-team-s-title">
          {{ $t('Home.Components.TeamDescription.Tips5') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerHeight: 0,
      screenWidth: 0
    }
  },
  created() {
    window.addEventListener('resize', this.setSize) // 注册监听器
    this.setSize() // 页面创建时先调用一次
  },
  destroyed() {
    window.removeEventListener('resize', this.setSize)
  },
  methods: {
    setSize() {
      this.screenWidth = window.innerWidth
      if (this.screenWidth < 1000) {
        this.bannerHeight = 390
      } else if (this.screenWidth < 1200) {
        this.bannerHeight = 440
      } else if (this.screenWidth < 1400) {
        this.bannerHeight = 490
      } else if (this.screenWidth < 1600) {
        this.bannerHeight = 580
      } else {
        this.bannerHeight = 620
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../css/homeOld.scss';
.team {
  margin-bottom: 90px;
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif';
}
.team-title {
  padding: 20px 0 10px;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #121e26;
  line-height: 33px;
  display: none;
}
.team-s-title {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #121e26;
  max-width: 60%;
  margin: 0 auto;
  display: none;
}
/deep/.is-active {
  .team-title {
    display: block;
  }
  .team-s-title {
    display: block;
  }
}
.carousel-img {
  display: block;
  width: 100%;
  object-fit: contain;
}
.team-mobile {
  display: none;
  margin-top: 80px;
}
.team-main {
  width: 100%;
  margin-bottom: 30px;
  .mobile-team-title {
    padding: 20px 0 10px;
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    color: #121e26;
    line-height: 33px;
  }
  .mobile-team-s-title {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #121e26;
    max-width: 60%;
    margin: 0 auto;
  }
}
.team-card {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
@media screen and(max-width:1600px) {
  .team {
    margin-bottom: 60px;
  }
  .carousel-img {
    width: 80%;
  }
}
@media screen and(max-width:1000px) {
  .team-title {
    font-size: 20px;
    line-height: 26px;
  }
  .team-s-title {
    font-size: 14px;
  }
}
@media screen and(max-width:750px) {
  .carousel-box {
    display: none;
  }
  .team-mobile {
    display: block;
  }
}
</style>
